var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('b-card-body',{staticClass:"p-2"},[_c('ActionGroup',{ref:"actionGroup",attrs:{"current-query":_vm.query,"options":_vm.options,"operators":_vm.operators}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }